import styled from "styled-components";

const Highlight = styled.span`
	color: black;
	font-style: italic;
`;

export default Highlight;
